import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  Text,
  useDisclosure,
  useToast,
  Box,
  Tooltip,
  CheckboxGroup,
  Checkbox,
} from '@chakra-ui/react'
import { Input } from '../../../../../../components/Form'
import { Button } from '../../../../../../components/Button'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import React, { useEffect } from 'react'
import { FaRegStar } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { api } from '../../../../../../services/api'
import { useMutation, useQueryClient, useQuery } from 'react-query'
import { motion } from 'framer-motion'
import { ListContato } from './ListContato'
import { InputMaskForm } from '../../../../../../components/Form/InputMaskForm'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns'
import { formatPrice } from '../../../../../../utils/formatPrice'
import Axios from 'axios'
import { WarningEnderecoEditado } from '../../WarningEnderecoEditado'

async function searchCep(cep) {
  const response = await api.get(`/site/v2/pedido/busca-endereco-cliente/${cep}`)

  return response.data[0]
}

async function updateFaturamento({
  codigo_parceiro,
  cep,
  cnpj,
  complemento,
  nome_parceiro,
  numero_nota,
  email_parceiro,
  telefone,
  celular,
  ramal,
  codigo_contato,
  razao_social,
  numero,
  rua,
  bairro,
  cidade,
  uf,
  editar_endereco,
  inscricao_estadual,
}) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-endereco-faturamento', {
    codigo_parceiro,
    cep,
    cnpj,
    complemento,
    nome_parceiro,
    numero_nota,
    email_parceiro,
    telefone,
    celular,
    ramal,
    codigo_contato,
    razao_social,
    numero,
    rua,
    bairro,
    cidade,
    uf,
    editar_endereco,
    inscricao_estadual,
  })

  return response.data
}

const schema = z.object({
  editar_endereco: z.boolean(),
  telefone: z.string().nonempty('Campo obrigatório'),
  ramal: z.string().optional(),

  cep: z
    .string()
    .nonempty('Campo obrigatório')
    .refine((cep) => cep.replace(/[^0-9]/g, '')?.length === 8, {
      message: 'CEP inválido',
    }),

  endereco: z.string().nonempty('Campo obrigatório'),
  numero: z.string().nonempty('Campo obrigatório'),
  complemento: z.string().optional(),
  bairro: z.string().nonempty('Campo obrigatório'),
  cidade: z.string().nonempty('Campo obrigatório'),
  estado: z.string().nonempty('Campo obrigatório'),
  email: z.string().optional(),
  razaoSocial: z.string().nonempty('Campo obrigatório'),
  cpfCnpj: z.string().nonempty('Campo obrigatório'),
  codParc: z.string().nonempty('Campo obrigatório'),
  ie: z.string().optional(),
})

export function ModalCliente({ infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [searchParceiro, setSearchParceiro] = React.useState(false)
  const [parceiroSelecionado, setParceiroSelecionado] = React.useState(null)
  const { pedidoBloqueado } = useOrcamentoPedido()
  const { numeroProposta: numProposta } = useParams()

  const btnRef = React.useRef()
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
    control,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const cep = watch('cep')
  const editarEndereco = watch('editar_endereco')

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateFaturamento,
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...data,
            ...oldData,
            nome_contato: data.nome_contato,
            info_contato: data.info_contato,
            total_valor_pedidos: formatPrice(data.total_valor_pedidos),
            razao_social: data.razao_social,
            cliente: {
              ...data.cliente,
              data_retorno: data.cliente.data_retorno ? format(new Date(data.cliente.data_retorno), 'dd/MM/yyyy') : null,
            },
            dados_entrega: data.dados_entrega,
            contato_site: data.contato_site,

            tipos_funil: data.tipos_funil.map((tipo) => {
              return { value: tipo.codigo_funil_venda, label: tipo.tipo_funil_venda }
            }),

            info_faturamento: {
              ...data.info_faturamento,
              atualiza_vendedor: data.info_faturamento.atualiza_vendedor,
            },
            tipos_verba: data.tipos_verba.map((verba) => {
              return { value: verba.id, label: verba.valor }
            }),

            info_tipo: data.info_tipo.map((tipo) => {
              return { value: parseInt(tipo.id_tipo), label: tipo.tipo_uso }
            }),

            empresas: data.empresas.map((empresa) => {
              return { value: empresa.codigo_empresa, label: empresa.razao_social }
            }),

            historico_pagamento: data.historico_pagamento.map((historico) => {
              return {
                ...historico,
                data_negociacao: format(new Date(historico.data_negociacao), 'dd/MM/yyyy'),
                valor_nota: formatPrice(historico.valor_nota),
                dias_atraso: historico.dias_atraso,
                original_data_negociacao: historico.data_negociacao,
                data_pagamento: format(new Date(historico.data_pagamento), 'dd/MM/yyyy'),
              }
            }),

            dados_retorno: data.dados_retorno.map((item) => {
              return {
                ...item,
                data_contato: item.data_contato ? format(new Date(item.data_contato), "dd/MM/yyyy '|' HH:mm") : '',
                data_agendamento: item.data_agendamento ? format(new Date(item.data_agendamento), "dd/MM/yyyy '|' HH:mm") : '',
                tipo_chamado: item.tipo_chamado ?? 'Sem tipo',
              }
            }),
          },
        }
      })

      // queryClient.invalidateQueries(['items', numProposta]);

      onClose()

      toast({
        title: 'Dados de entrega atualizados com sucesso',
        status: 'success',
      })
    },

    onError: (error) => {
      toast({
        title: 'Erro ao atualizar os dados de faturamento',
        description: error?.response?.data?.erros,
        status: 'error',
      })
    },
  })

  const {
    data: endereco,
    isLoading: loadingEndereco,
    refetch,
  } = useQuery({
    queryKey: 'endereco',
    queryFn: () => searchCep(cep),
    refetchOnWindowFocus: false,
    enabled: false,
    staleTime: 1000 * 60 * 10,
    onSuccess: (data) => {
      setValue('endereco', data.rua)
      setValue('bairro', data.bairro)
      setValue('cidade', data.cidade)
      setValue('estado', data.uf)
    },
    onError: (error) => {
      toast({
        title: 'CEP não encontrado',
        status: 'error',
      })
    },
  })

  async function handleUpdateCliente(data) {
    const params = {
      codigo_parceiro: data.codParc,
      cep: data.cep,
      razao_social: data.razaoSocial,
      cnpj: data.cpfCnpj,
      complemento: data.complemento,
      nome_parceiro: data.razaoSocial,
      numero_nota: infoProposta.num_proposta,
      email_parceiro: data.email,
      telefone: data.telefone,
      celular: data.celular,
      ramal: data.ramal,
      codigo_contato: infoProposta.cliente.codigo_contato,
      numero: data.numero,
      rua: data.endereco,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.estado,
      editar_endereco: data.editar_endereco,
      inscricao_estadual: data.ie,
    }

    await mutateAsync(params)
  }

  async function handleSearchCep(data) {
    await refetch()
    setValue('editar_endereco', true)
  }

  useEffect(() => {
    setValue('telefone', infoProposta?.cliente?.telefone)
    setValue('celular', infoProposta?.cliente?.celular)
    setValue('ramal', infoProposta?.cliente?.ramal)
    setValue('cep', infoProposta?.cliente?.cep)
    setValue('endereco', infoProposta?.cliente?.endereco)
    setValue('numero', infoProposta?.cliente?.numero)
    setValue('complemento', infoProposta?.cliente?.complemento)
    setValue('bairro', infoProposta?.cliente?.bairro)
    setValue('cidade', infoProposta?.cliente?.cidade)
    setValue('estado', infoProposta?.cliente?.sigla)
    setValue('caixaPostal', infoProposta?.cliente?.caixa_postal)
    setValue('email', infoProposta?.cliente?.email)
    setValue('razaoSocial', infoProposta?.cliente?.razao_social)
    setValue('cpfCnpj', infoProposta?.cliente?.cnpj)
    setValue('codParc', infoProposta?.cliente?.codigo_parceiro)
    setValue('ie', infoProposta?.cliente?.inscricao_estadual)
    setValue('editar_endereco', infoProposta?.info_faturamento?.atualiza_vendedor)
  }, [infoProposta?.cliente, setValue, onOpen, infoProposta?.info_faturamento])

  //   const dataAddresApi = {
  //     rua: endereco.rua,
  //     bairro: endereco.bairro,
  //     cidade: endereco.cidade,
  //     uf: endereco.uf,
  //   }

  //   const addresClient = {
  //     rua: watch('endereco'),
  //     bairro: watch('bairro'),
  //     cidade: watch('cidade'),
  //     uf: watch('estado'),
  //   }

  //   const isEnderecoEqual =
  //     dataAddresApi.rua === addresClient.rua &&
  //     dataAddresApi.bairro === addresClient.bairro &&
  //     dataAddresApi.cidade === addresClient.cidade &&
  //     dataAddresApi.uf === addresClient.uf

  //   useEffect(() => {
  //     //dispara um warning para o vendedor, falando que ele está sobrescrevendo o endereço do cliente, se ele estiver realmente sobrescrevendo o que vem da api
  //     if (endereco) {
  //       if (!isEnderecoEqual) {
  //         toast({
  //           title: 'Você está sobrescrevendo o endereço do sistema',
  //           status: 'warning',
  //           duration: 10000,
  //         })

  //         return
  //       }

  //       toast.closeAll()
  //     }
  //   }, [isEnderecoEqual, endereco, toast])

  return (
    <>
      <Flex alignItems="center" gap={2} cursor={'pointer'} onClick={onOpen}>
        <Icon as={FaRegStar} color="#378BBF" fontSize="20px" />{' '}
        <Tooltip label={infoProposta?.razao_social}>
          <Text maxW="full" isTruncated>
            {infoProposta.razao_social}
          </Text>
        </Tooltip>{' '}
        | <strong>{infoProposta.cliente.codigo_parceiro}</strong>
        <Icon as={FiEdit} color="#378BBF" fontSize="20px" />
      </Flex>

      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <Text bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase" py="14px" fontWeight="semibold">
            <strong>CONTATO</strong> | {infoProposta.razao_social} | <strong>{infoProposta.cliente.codigo_parceiro}</strong>
          </Text>

          {!searchParceiro && (
            <>
              <DrawerBody
                maxW="500px"
                w="100%"
                mx="auto"
                display="flex"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
                gap={10}
                as="form"
                onSubmit={handleSubmit(handleUpdateCliente)}
              >
                <Flex w="100%" flexDir="column" gap={2}>
                  <Flex alignItems="end" gap={2} mt={5}>
                    <Input label="Cod Parc" width="53px" id="codParc" {...register('codParc')} name="codParc" error={errors.codParc} disabled />
                    <Button maxW="181px" w="100%" fontSize="13px" fontWeight="semibold" size="sm" onClick={() => setSearchParceiro(true)} visibility={pedidoBloqueado ? 'hidden' : 'visible'}>
                      Pesquisar parceiro
                    </Button>
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <InputMaskForm
                      control={control}
                      label="CPF/Cnpj"
                      width="142px"
                      id="cpfCnpj"
                      name="cpfCnpj"
                      error={errors.cpfCnpj}
                      mask={watch('cpfCnpj')?.length === 14 ? '99.999.999/9999-99' : '999.999.999-99'}
                      disabled={pedidoBloqueado}
                    />
                    <Input label="Razão Social" id="razaoSocial" {...register('razaoSocial')} name="razaoSocial" error={errors.razaoSocial} disabled={pedidoBloqueado} />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    {/* Inscrição estadual */}
                    <Input label="IE" id="ie" {...register('ie')} name="ie" error={errors.ie} disabled={pedidoBloqueado} />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <InputMaskForm label="Telefone" control={control} id="telefone" name="telefone" error={errors.telefone} mask="(99) 9999-9999" disabled={pedidoBloqueado} />
                    <Input label="Ramal" id="ramal" {...register('ramal')} name="ramal" error={errors.ramal} disabled={pedidoBloqueado} />
                  </Flex>
                  <Flex alignItems="start" flexDir="column" gap={2} visibility={pedidoBloqueado ? 'hidden' : 'visible'}>
                    <CheckboxGroup>
                      <Flex alignItems="center" gap={2}>
                        <Checkbox id="editar_endereco" {...register('editar_endereco')} isChecked={editarEndereco} disabled={editarEndereco} />

                        <Text as="label" fontSize="12px" htmlFor="editar_endereco">
                          Editar endereço
                        </Text>
                      </Flex>
                    </CheckboxGroup>
                  </Flex>
                  <Flex alignItems="end" gap={2}>
                    <InputMaskForm control={control} label="CEP" id="cep" name="cep" error={errors.cep} mask="99999-999" disabled={pedidoBloqueado} />

                    <Button
                      maxW="142px"
                      w="100%"
                      fontSize="13px"
                      fontWeight="semibold"
                      size="sm"
                      isLoading={loadingEndereco}
                      onClick={handleSearchCep}
                      visibility={pedidoBloqueado ? 'hidden' : 'visible'}
                    >
                      Pesquisar CEP
                    </Button>
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Box position="relative" w="100%" _disabled={pedidoBloqueado}>
                      {infoProposta?.info_faturamento?.atualiza_vendedor && <WarningEnderecoEditado />}
                      <Input
                        label="Endereço"
                        id="endereco"
                        {...register('endereco')}
                        name="endereco"
                        disabled={!editarEndereco || pedidoBloqueado}
                        error={errors.endereco}
                      />
                    </Box>
                    <Input label="Número" id="numero" width="142px" {...register('numero')} name="numero" error={errors.numero} disabled={pedidoBloqueado} />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Box position="relative">
                      {infoProposta?.info_faturamento?.atualiza_vendedor && <WarningEnderecoEditado />}
                      <Input label="Bairro" id="bairro" {...register('bairro')} name="bairro" error={errors.bairro} disabled={!editarEndereco || pedidoBloqueado} />
                    </Box>
                    <Input
                      label="Complemento"
                      id="complemento"
                      width="142px"
                      {...register('complemento')}
                      name="complemento"
                      error={errors.complemento}
                      disabled={pedidoBloqueado}
                    />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Box position="relative" w="full">
                      {infoProposta?.info_faturamento?.atualiza_vendedor && <WarningEnderecoEditado />}
                      <Input label="Cidade" id="cidade" {...register('cidade')} name="cidade" error={errors.cidade} disabled={!editarEndereco || pedidoBloqueado} />
                    </Box>
                    <Box position="relative" w="full">
                      {infoProposta?.info_faturamento?.atualiza_vendedor && <WarningEnderecoEditado />}
                      <Input
                        label="Estado"
                        id="estado"
                        width="142px"
                        {...register('estado')}
                        name="estado"
                        disabled={!editarEndereco || pedidoBloqueado}
                        error={errors.estado}
                      />
                    </Box>
                  </Flex>
                  <Input label="Email" id="email" {...register('email')} name="email" error={errors.email} disabled={pedidoBloqueado} />
                </Flex>

                <Flex alignItems="center" justifyContent="space-between" w="100%">
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    bgColor="transparent"
                    color="#FFA200"
                    border="1px solid #FFA200"
                    //fecha modal
                    onClick={onClose}
                  >
                    <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                    Voltar
                  </Button>
                  <Button maxW="181px" w="100%" fontSize="15px" fontWeight="semibold" type="submit" isLoading={isLoading} visibility={pedidoBloqueado ? 'hidden' : 'visible'}>
                    salvar alteração
                  </Button>
                </Flex>
              </DrawerBody>
            </>
          )}

          {searchParceiro && (
            <DrawerBody maxW="900px" w="100%" mx="auto" display="flex" flexDir="column" alignItems="center" justifyContent="center" gap={10}>
              <Box
                as={motion.div}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                w="100%"
                display="flex"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
                gap={10}
              >
                <ListContato setParceiroSelecionado={setParceiroSelecionado} parceiroSelecionado={parceiroSelecionado} setValue={setValue} />

                <Flex alignItems="center" justifyContent="space-between" w="100%">
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    bgColor="transparent"
                    color="#FFA200"
                    border="1px solid #FFA200"
                    //fecha modal
                    onClick={() => setSearchParceiro(false)}
                  >
                    <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                    Voltar
                  </Button>
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    isLoading={isLoading}
                    isDisabled={!parceiroSelecionado}
                    //volta para a tela de cadastro
                    onClick={() => {
                      setValue('codParc', parceiroSelecionado?.codigo_parceiro)
                      setValue('cpfCnpj', parceiroSelecionado?.cnpj)
                      setValue('razaoSocial', parceiroSelecionado?.razao_social)
                      setValue('endereco', parceiroSelecionado?.endereco)
                      setValue('numero', parceiroSelecionado?.numero)
                      setValue('complemento', parceiroSelecionado?.complemento)
                      setValue('bairro', parceiroSelecionado?.bairro)
                      setValue('cidade', parceiroSelecionado?.cidade)
                      setValue('estado', parceiroSelecionado?.sigla)
                      setValue('email', parceiroSelecionado?.email_parceiro)
                      setValue('cep', parceiroSelecionado?.cep)
                      setValue('telefone', parceiroSelecionado?.telefone)
                      setValue('ramal', parceiroSelecionado?.ramal)
                      setValue('ie', parceiroSelecionado?.inscricao_estadual)
                      setValue('editar_endereco', parceiroSelecionado?.editar_endereco)
                      setSearchParceiro(false)
                    }}
                  >
                    Confirmar
                  </Button>
                </Flex>
              </Box>
            </DrawerBody>
          )}
        </DrawerContent>
      </Drawer>
    </>
  )
}
